import  { lazy } from 'react';
import Auth from "../../hoc/Auth";

const walletPaymentPromise = import("./ProcessWalletPayment.js");
export default Auth(lazy(() => walletPaymentPromise));